import React from 'react';
import { Card } from '../ui';

const GalleryCardSkeleton = () => {
  return (
    <Card className='overflow-hidden'>
      <div className='relative'>
        <div className='skeleton w-full h-64'></div>
      </div>
    </Card>
  );
};

const GalleryPageSkeleton = ({ count = 6 }) => {
  return (
    <div className='space-y-6'>
      <div className='flex items-center justify-between'>
        <div className='skeleton h-8 w-48 rounded'></div>
        <div className='skeleton h-5 w-32 rounded'></div>
      </div>

      <div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6'>
        {Array.from({ length: count }).map((_, index) => (
          <GalleryCardSkeleton key={index} />
        ))}
      </div>
    </div>
  );
};

export default GalleryPageSkeleton;
